<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eZSnHx/tc-custom/9780544232891.jpg?1726339887461" alt="This image is the cover for the book Third Rail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Third Rail
      </h1>
      <p class="bookDescription body article font2">
        <b>“<i>Third Rail </i>gets off to a ripping start and never lets off the gas. Rory Flynn is a suspense writer to watch.”—Jess Walter, author of the best-selling <i>Beautiful Ruins</i></b><br/>  <br/> Harvard-educated Eddy Harkness was a rising star in an elite Boston Police Department narcotics unit—until he was blamed for the death of a Red Sox fan in the chaotic aftermath of a World Series win. Scapegoated and exiled, Harkness now empties parking meters in the sleepy town of Nagog while struggling to clear his name.<br/>  <br/> Then one night his police-issued Glock disappears. Unable to report the theft, he starts a secret search—just as a string of fatal accidents leads him to uncover a dangerous new smart drug, Third Rail. With only a plastic gun to protect him, Harkness begins a high-stakes investigation that leads him into the top levels of Boston’s power base, where politicians and criminals intertwine to deadly effect.<br/>  <br/> “Glows with the kind of sawdust-dry humor regarding Beantown, cops, and the darkest of urban underbellies that you might find at 3 a.m. in the back booth of a backstreet bar . . . With its gaggle of crazy-yet-riveting characters, its spare approach, and its unflagging action, <i>Third Rail</i><i>,</i> the first in a promised series of Eddy Harkness novels, adds yet another striking feather to [Flynn’s] impressively crowded cap.” —<i>Boston Globe</i><br/>  <br/> “Terrific debut . . . impressive economy and stylish, sophisticated prose . . . Readers will want to see more of Flynn’s gritty Boston—and Eddy Harkness.”<i>—Publishers Weekly,</i> starred review
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rory Flynn
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a48c380